import {
    ItemFieldTemplate,
    ItemFieldTemplateContent,
    ItemFieldTemplateRequest,
} from 'store/item-field-templates/itemFieldTemplate';
import { DeclarationExternalEntity } from 'store/declarations/enums/common/declaration-external-entity';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';

type Params = {
    name: string;
    teamId?: string;
    template: ItemFieldTemplateContent;
    loadedTemplate?: ItemFieldTemplate;
    route: { externalEntity?: string; internalType?: string | false; type?: string };
};

const toItemFieldTemplateRequest = ({
    name,
    teamId,
    template,
    loadedTemplate,
    route,
}: Params): ItemFieldTemplateRequest | undefined => {
    const declarationExternalEntity = loadedTemplate?.declarationExternalEntity ?? route.externalEntity;
    const declarationInternalType = loadedTemplate?.declarationInternalType ?? route.internalType;
    const declarationName = loadedTemplate?.declarationName ?? route.type;

    if (!declarationExternalEntity || !declarationInternalType || !declarationName) return undefined;

    return {
        name,
        teamId,
        template,
        declarationExternalEntity: declarationExternalEntity as DeclarationExternalEntity,
        declarationInternalType: declarationInternalType as DeclarationInternalType,
        declarationName,
    };
};

export default toItemFieldTemplateRequest;
